import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';
import type { ActivateFunction } from '@elfsight/widget-utils';

interface WithTriggersProps extends PropsWithChildren {
  onActivate: (
    triggerName: string,
    triggerPayload?: string | number | boolean
  ) => void;
  triggers: ActivateFunction[];
}

export function useApplyTriggers({ onActivate, triggers }: WithTriggersProps) {
  const [activatedTriggerName, setActivatedTriggerName] = useState<
    string | null
  >(null);
  const [activatedTriggerNamePayload, setActivatedTriggerPayload] =
    useState<any>();

  useEffect(() => {
    if (activatedTriggerName !== null || !triggers || triggers.length === 0) {
      return;
    }

    const triggersCleanups = triggers.map((registrationFn) => {
      if (typeof registrationFn !== 'function') {
        throw new Error('Trigger must be a function');
      }

      return registrationFn(
        setActivatedTriggerName,
        setActivatedTriggerPayload
      );
    });

    return () => {
      triggersCleanups.forEach((cleanupFn) => {
        if (typeof cleanupFn === 'function') {
          cleanupFn();
        }
      });
    };
  }, [triggers, activatedTriggerName]);

  useEffect(() => {
    if (activatedTriggerName !== null) {
      onActivate(activatedTriggerName, activatedTriggerNamePayload);
    }
  }, [activatedTriggerName, activatedTriggerNamePayload]);
}
